<template>
    <div class="home" v-if="semiannual">
        <b-container fluid>
            <b-row>
                <b-col>
                    <h1>Facility Nurse Aide Staff Report review for {{semiannual.facilityName}}</h1>
                </b-col>
            </b-row>
            <div class="card">
                <div class="card-header">Facility Nurse Aide Staff Report review</div>
                <div class="card-body">
                    <b-row>
                        <b-col cols="3">
                            <BaseTextOutput label="Facility Name" :value="semiannual.facilityName"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="HFID" :value="semiannual.hfid"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="3">
                            <BaseTextOutput label="Street Address" :value="semiannual.address.streetAddress"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="City" :value="semiannual.address.city"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="State" :value="semiannual.address.state"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="Zip" :value="semiannual.address.postalCode"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="3">
                            <BaseTextOutput label="Facility Nurse Aide Staff Report Status" :value="semiannual.status.description"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="Facility Nurse Aide Staff Report Date" :value="formatDate(semiannual.submittedDate)"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="Review Date" :value="formatDate(semiannual.reviewDate)"/>
                        </b-col>
                    </b-row>
                    <hr/>
                </div>
                <div v-for="(cna, index) in semiannual.cnas" :key="index">
                    <h2>CNA {{index+1}} of {{semiannual.cnas.length}}</h2>
                    <b-row>
                        <b-col cols="3">
                            <BaseTextOutput label="First Name" :value="cna.firstName"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="Middle Name" :value="cna.middleName"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="Last Name" :value="cna.lastName"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="SSN" :value="cna.ssn"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="3">
                            <BaseTextOutput label="Certificate #" :value="cna.certificateNumber"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="Certificate Expiration Date" :value="formatDate(cna.certificateExpirationDate)"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="Registry status" :value="cna.active.description"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="Complaints" :value="cna.complaints?cna.complaints.code:'N/A'"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="3">
                            <BaseTextOutput label="Work status at facility" :value="cna.workStatus.description"/>
                        </b-col>
                        <b-col cols="3" v-if="cna.workStatus.code==='OTH'">
                            <BaseTextOutput label="Other Work Status" :value="cna.otherWorkStatus"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="Last Worked Date" :value="formatDate(cna.lastWorkedDate)"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <BaseSelector v-model="cnaDecisions[index].decision"
                                          :v="$v.cnaDecisions.$each[index].decision"
                                          label="Review Decision"
                                          :options="cnaDecisionOptions"
                                          :setId="'cnaDecision'+index"/>
                        </b-col>
                    </b-row>
                    <hr/>
                </div>
                <b-row>
                    <b-col>
                        <b-button variant="primary" @click="submit">Submit Review</b-button>
                    </b-col>
                </b-row>
            </div>
        </b-container>
    </div>
</template>

<script>
    import BaseTextOutput from "@/components/templates/input/BaseTextOutput";
    import BaseSelector from "@/components/templates/input/BaseSelector";
    import axios from 'axios';
    import {required} from 'vuelidate/lib/validators';
    import moment from 'moment';

    export default {
        name: "SemiannualReview",
        components:{
            BaseTextOutput,
            BaseSelector
        },
        data:() =>({
            semiannual: null,
            cnaFields:[
                {key:'firstName', label:'First Name',}
            ],
            cnaDecisions: [],
            cnaDecisionOptions: [],
        }),
        created(){
            this.loadSemiannual();
            this.loadCnaDecisions();
        },
        methods:{
            loadSemiannual(){
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/semiannual/admin/get/${this.$route.params.id}`)
                    .then(response=>{
                        this.semiannual=response.data;
                        for(let i = 0; i<response.data.cnas.length;i++){
                            this.cnaDecisions.push({
                                id: response.data.cnas[i].id,
                                decision: null
                            })
                        }
                    })
                    .catch(error=>{
                        console.log("failed to load semiannual")
                    })
            },
            loadCnaDecisions(){
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/semiannual/admin/getReviewStatuses`)
                    .then(response=>{
                        for(let i=0;i<response.data.length;i++){
                            this.cnaDecisionOptions.push({
                                value: response.data[i].code,
                                text: response.data[i].description
                            })
                        }
                    })
            },
            formatDate(unformattedDate){
                let formattedDate = moment(unformattedDate);
                if(!formattedDate.isValid()) return '';
                return formattedDate.format("MM/DD/YYYY")
            },
            submit(){
                this.$v.$touch();
                if(this.$v.$invalid){
                    return;
                }
                axios.post(`${process.env.VUE_APP_API_BASE_URL}/semiannual/admin/review/${this.semiannual.id}`,this.cnaDecisions)
                    .then(response=>{
                        this.showRootToast("Submitted review.","The review for this Facility Nurse Aide Staff Report has been successfully submitted","success");
                        this.loadSemiannual();
                    })
                    .catch(error=>{
                        this.showRootToast("Error submitting review","The review for this Facility Nurse Aide Staff Report has failed to submit","danger");
                    })
            },
            showRootToast(title, message, type) {
                this.$root.$bvToast.toast(message, {
                    title: title,
                    toaster: 'b-toaster-top-center',
                    solid: true,
                    variant: type,
                    appendToast: true,
                    noAutoHide:true
                })
                this.toastFocus()
            },
            toastFocus() {
                setTimeout(() => {
                    let elem = document.getElementsByClassName("toast")
                    elem = elem[elem.length-1]
                    elem.focus()
                }, 100)
            },
        },
        validations(){
            return{
                cnaDecisions: {
                    required,
                    $each:{
                        decision: {required}
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>